import { render } from "./CalendarEventTile.vue?vue&type=template&id=2cadfdb0&scoped=true"
import script from "./CalendarEventTile.vue?vue&type=script&lang=ts"
export * from "./CalendarEventTile.vue?vue&type=script&lang=ts"

import "./CalendarEventTile.vue?vue&type=style&index=0&id=2cadfdb0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2cadfdb0"

export default script